import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";

type NavigationItem = {
  id: string;
  label: string;
};

type PromptLibraryNavigationProps = {
  items: NavigationItem[];
  customSectionsCount: number;
};

function scrollToCategory(categoryId: string) {
  const element = document.getElementById(categoryId);
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export function PromptLibraryNavigation({
  items,
  customSectionsCount,
}: PromptLibraryNavigationProps) {
  if (items.length === 0) return null;

  return (
    <>
      <div className="shrink-0 overflow-x-auto bg-muted/30 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        <nav className="flex items-center gap-1 p-2 px-4 min-w-max">
          {items.map((item, index) => {
            const showSeparator =
              customSectionsCount > 0 &&
              index === customSectionsCount - 1 &&
              index < items.length - 1;

            return (
              <div key={item.id} className="flex items-center gap-1">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => scrollToCategory(item.id)}
                  className={cn(
                    "rounded-full text-sm font-medium whitespace-nowrap",
                    "text-muted-foreground hover:text-foreground",
                  )}
                >
                  {item.label}
                </Button>
                {showSeparator && (
                  <span className="mx-1 text-muted-foreground/40">|</span>
                )}
              </div>
            );
          })}
        </nav>
      </div>
      <Separator />
    </>
  );
}
